import styled from '@emotion/styled'
import { ITheme } from 'application/utils/type'
import { Col } from 'react-bootstrap'

interface IInputProps {
  theme: ITheme
}

export const TickListDiv = styled.div`
  label: TickListDiv;
  display: flex;
  align-items: baseline;
  font-size: 18px;
  > img {
    height: 14px;
    padding-right: 6px;
  }
`
export const LeaseCardDiv = styled.div`
  label: LeaseCardDiv;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  border-radius: 12px;
  box-shadow: 0px 2px 16px rgba(0, 0, 0, 0.16);
  -webkit-box-shadow: 0px px 16px rgba(0, 0, 0, 0.16);
  @media (max-width: 719px) {
    box-sizing: border-box;
    padding: 18px;
    margin-top: 18px;
    align-items: flex-start;
    justify-content: flex-start;
    border: 1px solid ${(props: IInputProps) => props.theme.colors.borderColor};
  }
`

export const LeaseCardIcon = styled.img`
  label: LeaseCardIcon;
  height: 60px;
  margin-top: 18px;
  margin-bottom: 18px;
  @media (max-width: 719px) {
    display: none;
  }
`

export const LeaseCardTitle = styled.div`
  label: LeaseCardTitle;
  font-size: ${(props: IInputProps) => props.theme.font.size.smaller};
  @media (max-width: 719px) {
    font-size: ${(props: IInputProps) => props.theme.font.size.medium};
    text-transform: uppercase;
    margin-bottom: 18px;
  }
`

export const LeaseCardAmountDiv = styled.div`
  label: LeaseCardAmountDiv;
  color: ${(props: IInputProps) => props.theme.colors.textLightblack};
  font-size: 28px;
  line-height: 34px;
  margin-bottom: 18px;
`

export const LeaseCardSubText = styled.div`
  label: LeaseCardSubText;
  font-size: 12px;
  margin-bottom: 18px;
  @media (max-width: 719px) {
    font-size: ${(props: IInputProps) => props.theme.font.size.smaller};
    margin-bottom: 0px;
  }
`

export const LeaseCardGreyBlock = styled.div`
  lable: LeaseCardGreyBlock;
  background-color: ${(props: IInputProps) =>
    props.theme.backgrounds.backGround3};
  width: 100%;
  padding-top: 80px;
  @media (max-width: 719px) {
    display: none;
  }
`

export const BenefitsToggleParentDiv = styled.div`
  label: BenefitsToggleParentDiv;
  display: flex;
  align-items: center;
  flex-direction: column;
`

export const BenefitsToggleHRDiv = styled.div`
  label: BenefitsToggleHRDiv;
  width: 100%;
`

export const BenefitsToggleTextDiv = styled.div`
  label: BenefitsToggleTextDiv;
  position: relative;
  top: -15px;
  background-color: ${(props: IInputProps) =>
    props.theme.backgrounds.backGround3};
  width: 220px;
  cursor: pointer;
`

export const BenefitsToggleText = styled.button`
  label: BenefitsToggleText;
  color: ${(props: any) => props.theme.colors.textDarkblack};
  font-size: 12pt;
  text-decoration-line: underline;
  font-weight: ${(props: any) => props.theme.font.weight.bold};
  border: none;
  background: none;
`

export const GreenNumberCircle = styled.span`
  label: GreenNumberCircle;
  padding: 12px;
  background-color: ${(props: any) => props.theme.colors.alertGreen};
  color: ${(props: any) => props.theme.colors.white};
  height: 35px;
  width: 35px;
  text-align: center;
  border-radius: 50%;
  display: inline-block;
  vertical-align: middle;
  line-height: 12px;
  margin-right: 24px;
`

export const NumberedBulletPointHeadingDiv = styled.div`
  label: NumberedBulletPointHeadingDiv;
  display: flex;
  align-items: center;
  margin-bottom: 12px;
`

export const StyledH2 = styled.h2`
  label: StyledH2;
  font-size: 28px !important;
  color: ${(props: IInputProps) => props.theme.colors.textDarkblack} !important;
`

export const IndentedP = styled.p`
  label: IndentedP;
  margin-left: 78px;
  margin-bottom: 60px !important;
`

export const StyledLink = styled.a`
  label: StyledLink;
  color: ${(props: IInputProps) =>
    props.theme.brand === 'Maxxia' ? '#000' : props.theme.colors.primary};
  font-weight: ${(props: IInputProps) =>
    props.theme.brand === 'Maxxia' ? 500 : 900};
  text-decoration: underline;
`

export const ContentSectionCol = styled(Col)`
  label: ContentSectionCol;
  padding-left: 0px;
  @media (max-width: 719px) {
    padding-left: 15px;
  }
`
